export interface PagedListOptions {
  limit?: number;
  cursor?: string | null;
  /**
   * Server-side search query. Passed straight through to the list
   * endpoints so every list capsule (browse / community / github /
   * ai-create / favorites) hits the server on search commit instead
   * of filtering a stale client cache.
   */
  search?: string;
  /**
   * Sort order for endpoints that support it (e.g. community ideas:
   * "newest" or "votes"). Ignored by endpoints that don't.
   */
  sort?: string;
}

export interface TopicCatalogOptions extends PagedListOptions {
  category?: string | null;
  /** Filter by topic source (e.g. "github_trending" for the Trending section). */
  source?: string | null;
}

export interface TopicTrendingOptions extends PagedListOptions {
	category?: string | null;
}

export interface TopicNewestOptions extends PagedListOptions {
	category?: string | null;
	source?: string | null;
}

export function pagedQuery(params: object): string {
  const normalized = { ...(params as Record<string, string | number | null | undefined>) };
  if (normalized.limit === null || normalized.limit === undefined || normalized.limit === "") normalized.limit = 20;
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(normalized)) {
    if (value === null || value === undefined || value === "") continue;
    search.set(key, String(value));
  }
  return search.toString();
}
